import { useEffect, useState } from 'react';

/**
 * Which theme the phone is in.
 *
 * CSS handles this on its own through `prefers-color-scheme`; this hook exists for the one
 * thing CSS cannot reach — a canvas chart, whose colours are values passed to a drawing API
 * rather than properties resolved by the browser.
 */
export function useColorScheme(): 'light' | 'dark' {
  const [scheme, setScheme] = useState<'light' | 'dark'>(() =>
    typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light',
  );

  useEffect(() => {
    const query = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = (event: MediaQueryListEvent) => setScheme(event.matches ? 'dark' : 'light');
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return scheme;
}
